export default __webpack_public_path__ + "static/fireplace-416042_1280-5e5203dbdabd9fd7e86bcb13d61c96ac.png";